import React, { useState } from 'react';
import './PermissionOption.css';
import nextIcon from '../../../../assets/nextIcon.png';
import arrowExpand from '../../../../assets/arrowExpand.png'

const PermissionOption = ({ 
  title,
  children = [],
  currentValues = [],
  onChange
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handlePermissionChange = (permission, childId) => {
    // Encontrar el módulo actual en los valores
    let currentModule = currentValues.find(m => m.module_id === childId);
    
    // Si no existe el módulo, crearlo
    if (!currentModule) {
      currentModule = {
        module_id: childId,
        permissions: []
      };
      currentValues.push(currentModule);
    }

    // Si el permiso ya está seleccionado, quitarlo
    if (currentModule.permissions.includes(permission.id)) {
      currentModule.permissions = currentModule.permissions.filter(id => id !== permission.id);
    } else {
      // Si no está seleccionado, agregarlo
      currentModule.permissions.push(permission.id);
    }
    
    console.log('PermissionOption change:', { permission, childId, currentModule });
    onChange([...currentValues]);
  };

  const formatText = (text) => {
    // Primero manejamos casos especiales completos
    const fullText = text.toLowerCase();
    if (fullText === 'token_management') return 'Barter Bucks Management';
    if (fullText === 'roles_permissions_management') return 'Roles';
    if (fullText === 'support_management') return 'Support';
    if (fullText === 'activate_deactivate') return 'Activate/Desactivate';

    // Para otros casos, procesamos palabra por palabra
    return text
      .replace(/_/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Separa camelCase
      .split(' ')
      .map(word => {
        const lowerWord = word.toLowerCase();
        // Reemplazos específicos
        if (lowerWord === 'client') return 'Customer';
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  };

  const formatChildTitle = (name) => {
    // Primero manejamos casos especiales para el título base
    const basePart = title.split('_')[0].toLowerCase();
    let baseTitle;
    if (basePart === 'token') {
      baseTitle = 'Barter Bucks';
    } else if (basePart === 'roles') {
      baseTitle = 'Roles';
    } else if (basePart === 'support') {
      baseTitle = 'Support';
    } else {
      baseTitle = formatText(title.split('_')[0]);
    }

    // Procesamos la parte del hijo
    const childPart = formatText(name.replace(title.split('_')[0] + '_', ''));

    return `${baseTitle} - ${childPart}`;
  };

  return (
    <div className="permission-accordion">
      <div 
        className="accordion-header" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{formatText(title)}</span>
        <img src={isOpen ? arrowExpand : nextIcon} alt="icon" className="dropdown-icon" />
      </div>
      
      <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
        {children.map((child) => (
          <div key={child.id} className="permission-group">
            <h4>{formatChildTitle(child.name)}</h4>
            <div className="checkbox-group">
              {child.permissions.map((permission) => (
                <label key={permission.name}>
                  <input
                    type="checkbox"
                    checked={currentValues.some(m => m.module_id === child.id && Array.isArray(m.permissions) && m.permissions.includes(permission.id)) || false}
                    onChange={() => handlePermissionChange(permission, child.id)}
                    className="checkbox"
                  />
                  {formatText(permission.name)}
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PermissionOption;